/**
 * Active tenant resolution.
 *
 * Single helper used by pages that resolve "my company" directly from
 * `company_members`. When a Super Admin Support Session is active the active
 * tenant is the customer's company instead of the admin's own membership.
 *
 * This only overrides which company_id the UI queries with — authentication,
 * roles and Row Level Security are untouched and remain the final authority.
 */
import { supabase } from "@/integrations/supabase/client";
import { getSupportCompanyId } from "@/lib/supportSession";

export { getSupportCompanyId };

/** Resolve the company the UI should currently operate against. */
export async function resolveActiveCompanyId(userId: string): Promise<string | null> {
  const support = getSupportCompanyId();
  if (support) return support;

  const { data } = await supabase
    .from("company_members")
    .select("company_id")
    .eq("user_id", userId)
    .limit(1)
    .maybeSingle();

  return data?.company_id ?? null;
}
